<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <v-flex xs12>

        <v-toolbar flat>
          <h2>Контроллеры</h2>
          <v-dialog
            v-model="newControllerDialog"
            scrollable persistent modal
            width="640"
            transition="dialog-transition"
          >
            <template v-slot:activator="{ on }">
              <v-btn icon class="mx-3" color="secondary" v-on="on" :disabled="!isadmin">
                <v-icon>
                  add
                </v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="subtitle-1">
                Новый контроллер
                <v-spacer></v-spacer>
                <v-btn icon small @click="dialogNewControllerClose()"><v-icon>close</v-icon></v-btn>
              </v-card-title>
              <v-card-text>

                <v-text-field
                v-model="ititle"
                label="Название"
                ></v-text-field>

                <v-text-field
                v-model="iauthid"
                type="number"
                label="Идентификатор контроллера (8 цифр)"
                :rules="authidRules"
                ></v-text-field>

                <v-text-field
                v-model="iauthpassword"
                type="password"
                label="Пароль"
                ></v-text-field>

                <v-autocomplete
                flat
                label="Локация"
                :items="locations"
                v-model="ilocationid"
                item-text="name" item-value="locationid" clearable
                ></v-autocomplete>

                <v-autocomplete
                flat
                label="Обслуживаемые школы"
                :items="schools"
                v-model="ischools"
                multiple
                item-text="name" item-value="schoolid" clearable
                ></v-autocomplete>

                <v-text-field
                  v-model="ipaddr"
                  label="ip адрес VPN"
                  type="ip"
                  :rules="ipRules"
                  required
                />
              </v-card-text>
              <br /><br />

              <v-card-actions>
                <v-btn
                  color="primary"
                  :disabled="!iauthid || !iauthpassword || !ischools || !ilocationid || !ititle || !matchIP"
                  @click="addController()"
                >
                  Добавить
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn text
                  @click="dialogNewControllerClose()"
                >Отмена</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-spacer></v-spacer>

          <v-text-field
          label="поиск по фильтру"
          v-model="search"
          append-icon="search"
          style="max-width: 400px"
          outlined clearable hide-details flat
          ></v-text-field>

        </v-toolbar>
      </v-flex>
      <v-flex>
        <v-data-table no-data="пусто" no-data-text="пусто" no-results-text="ничего не найдено"
          :headers="headers"
          :items="controllers"
          :items-per-page="-1"
          :search="search"
          item-key="controllerid"
          sort-by="conn.age"
          hide-default-footer
          dense
        >
        <template v-slot:item.conn.text="{ item }">
          <span
            v-if="item.conn && item.conn.text"
            :style="item.conn.isconnected ? 'color: #2E7D32' : 'color: #D50000'"
          >{{ item.conn.text }}</span>
          <span v-else>?</span>
        </template>
        <template v-slot:item.ipaddr="{ item }">
          <span
            v-if="item.hasOwnProperty('online')"
            :style="`color: ${item.online ? '#2E7D32' : '#D50000' }`"
          >{{ item.ipaddr }}</span>
          <span v-else>{{ item.ipaddr }} ?</span>
        </template>
        <template v-slot:item.name="{ item }">
          <span
            class="primary--text text--darken-3"
            style="cursor: pointer;"
            @click="controller = item"
          >
            {{ item.name }}
          </span>
        </template>
        <template v-slot:item.cts="{ item }">
          {{ dateFormat(item.cts) }}
        </template>
        <template v-slot:item.action="{ item }" v-if="isadmin || isengineer">
          <v-menu bottom left>
            <template v-slot:activator="{ on }">
              <v-icon small v-on="on">more_vert</v-icon>
            </template>
            <v-list>
              <v-list-item
                dense
                @click=";reloadCards(item)"
              >
                <v-list-item-title>Перезагрузить карты: <b>{{ item.name }} @ {{ item.authid }}</b></v-list-item-title>
                <v-list-item-action><v-icon small>autorenew</v-icon></v-list-item-action>
              </v-list-item>
              <v-list-item
                v-if="item.online === true && isengineer"
                dense
                @click=";rebootController(item)"
              >
                <v-list-item-title>Ребутнуть контроллер: <b>{{ item.name }} @ {{ item.authid }}</b></v-list-item-title>
                <v-list-item-action><v-icon small>autorenew</v-icon></v-list-item-action>
              </v-list-item>
              <v-list-item
                v-if="item.online === true && isengineer"
                dense
                @click=";restartRtime(item)"
              >
                <v-list-item-title>Перезапустить rtime: <b>{{ item.name }} @ {{ item.authid }}</b></v-list-item-title>
                <v-list-item-action><v-icon small>autorenew</v-icon></v-list-item-action>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <DialogControllerConnections v-model="controller"></DialogControllerConnections>
  </v-container>
</template>

<script>
import moment from 'moment'
import { sub, unsub } from '@/bus'
import DialogControllerConnections from '@/components/DialogControllerConnections.vue'

export default {
  name: 'Controllers',
  components: {
    DialogControllerConnections
  },
  data: () => ({
    controllers: [],
    controller: null,
    search: '',
    sid1: null,
    sid2: null,
    schools: [],
    locations: [],
    ititle: 'Школа ',
    ischools: null,
    iauthid: '00000000',
    iauthpassword: '10733333',
    ilocationid: null,
    ipaddr: '',
    ipRules: [
      v => !!v || 'ip is required',
      v => /^(25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[0-9]{2}|[0-9])(\.(25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[0-9]{2}|[0-9])){3}$/
        .test(v) || 'ip must be valid'
    ],
    authidRules: [
      v => !!v || 'Требуется идентификатор',
      v => /^[0-9]{8}$/.test(v) || 'Идентификатор не валиден'
    ],
    newControllerDialog: false
  }),
  methods: {
    dateFormat (date) {
      return moment(date).format('YYYY-MM-DD HH:mm')
    },
    async fetch () {
      try {
        await this.fetchControllers()
        await this.fetchAdditional()
        await this.fetchSchools()
        await this.fetchLocations()
        // подписка на подключения контроллеров
        if (this.sid1) unsub(this.sid1)
        this.sid1 = sub('event-ac-controllers-connected', c => {
          console.log(c)
          this.controllers = this.controllers.map(x => {
            if (x.authid === c.controller.authid) {
              x.conn = c
              x.conn.last = moment()
              x.conn.isconnected = true
              x.conn.text = `Только что ${moment().format('HH:mm:ss')}`
              x.connAge = 0
            }
            return x
          })
        })
        if (this.sid2) unsub(this.sid2)
        this.sid2 = sub('event-ac-controllers-disconnected', c => {
          console.log(c)
          this.controllers = this.controllers.map(x => {
            if (x.authid === c.controller.authid && x.conn && x.conn.connectionid === c.connectionid) {
              x.conn = c
              x.conn.last = moment()
              x.conn.isconnected = false
              x.conn.text = `Только что ${moment().format('HH:mm:ss')}`
              x.connAge = 0
            }
            return x
          })
        })
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    async fetchControllers () {
      const { controllers } = await this.$store.dispatch('sioRequest', {
        topic: this.isadmin ? 'fetch-controllers-with-secrets' : 'fetch-controllers'
      })
      this.controllers = controllers.filter(c => c.ipaddr)
    },
    async fetchAdditional () {
      const data = (await Promise.all([
        this.$store.dispatch('sioRequest', { topic: 'fetch-locations' }),
        this.$store.dispatch('sioRequest', { topic: 'controllers-ip-online' }),
        this.$store.dispatch('sioRequest', { topic: 'controllers-connections' }),
      ]))
      const locations = data[0].locations.reduce((r, x) => {
        r[x.locationid] = x.name
        return r
      }, {})
      /* eslint-disable */
      const online = data[1].online
      .reduce((r, x) => {
        r[x] = x
        return r
      }, {})
      const connections = data[2].connections
      .map(x => {
        x.last = moment(x.closedat || x.cts)
        x.isconnected = !x.closedat
        x.text = x.last.fromNow()
        x.age = Math.abs(x.last.diff(moment(), 'seconds'))
        return x
      })
      .reduce((r, x) => {
        r[x.authid] = x
        return r
      }, {})
      /* eslint-enable */
      this.controllers = this.controllers.map(x => {
        x.online = !!online[x.controllerid]
        x.location = locations[x.locationid]
        const c = connections[x.authid]
        x.conn = c || ({
          isconnected: false,
          text: 'отключен',
          age: 10000000000,
        })
        return x
      })
    },
    async reloadCards (controller) {
      try {
        await this.$store.dispatch('confirm', `Перезагрузить карты для контроллера ${controller.name} @ ${controller.authid}?`)
        const { commands, meta } = await this.$store.dispatch('sioRequest', {
          topic: 'reload-cards',
          pl: {
            controllerid: controller.controllerid
          }
        })
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    async rebootController (controller) {
      try {
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'reboot-controller',
          pl: {
            controllerid: controller.controllerid
          }
        })
        this.$store.dispatch('snack', meta)
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    async restartRtime (controller) {
      try {
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'restart-rtime',
          pl: {
            controllerid: controller.controllerid
          }
        })
        this.$store.dispatch('snack', meta)
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    openDialog () {
      if (this.controller) {
        this.dialog = true
      }
    },
    async dialogNewControllerOpen () {
      this.newControllerDialog = true
    },
    dialogNewControllerClose () {
      this.newControllerDialog = false
      this.ititle = 'Школа '
      this.ischools = null
      this.iauthid = '00000000'
      this.iauthpassword = '10733333'
      this.ilocationid = null
      this.ipaddr = ''
    },
    async fetchSchools () {
      const { schools, meta } = await this.$store.dispatch('sioRequest', {
        topic: 'fetch-schools'
      })
      this.schools = schools
    },
    async fetchLocations () {
      const { locations, meta } = await this.$store.dispatch('sioRequest', {
        topic: 'fetch-locations'
      })
      this.locations = locations
    },
    async addController () {
      try {
        if (this.controllers.find(x => x.authid === this.iauthid)) throw new Error('Указанный идентификатор контроллера уже существует')
        if (this.controllers.find(x => x.ipaddr === this.ipaddr)) throw new Error('Указанный ip-адрес уже занят другим контроллером')
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'add-controller',
          pl: {
            name: this.ititle,
            authid: this.iauthid,
            authkey: '000102030405060708090a0b',
            authpassword: this.iauthpassword,
            locationid: this.ilocationid,
            schools: this.ischools,
            ipaddr: this.ipaddr
          }
        })
        this.$store.dispatch('snack', meta)
        this.dialogNewControllerClose()
      } catch (e) {
        this.$store.dispatch('snack', e)
      } finally {
        this.fetch()
      }
    }
  },
  computed: {
    profile () {
      return this.$store.state.profile
    },
    scopes () {
      return this.profile ? this.profile.scopes : []
    },
    isadmin () {
      return this.scopes.includes('admin')
    },
    isengineer () {
      return this.scopes.includes('engineer')
    },
    headers () {
      if (this.isadmin || this.isengineer) {
        return [
          { text: 'ipaddr', value: 'ipaddr', width: 125, align: 'right' },
          { text: 'link', value: 'conn.text', width: 130, align: 'left' },
          { text: 'title', value: 'name' },
          { text: 'schools', value: 'schools' },
          { text: 'controllerid', value: 'controllerid' },
          { text: 'authid', value: 'authid' },
          { text: 'authpassword', value: 'authpassword' },
          { text: 'cts', value: 'cts' },
          { text: 'location', value: 'location' },
          { text: 'действия', value: 'action', align: 'center', sortable: false },
        ]
      } else {
        return [
          { text: 'ipaddr', value: 'ipaddr', width: 125, align: 'right' },
          { text: 'link', value: 'conn.text', width: 130, align: 'left' },
          { text: 'title', value: 'name' },
          { text: 'schools', value: 'schools' },
          { text: 'controllerid', value: 'controllerid' },
          { text: 'cts', value: 'cts' },
          { text: 'location', value: 'location' },
        ]
      }
    },
    matchIP () {
      return /^(25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[0-9]{2}|[0-9])(\.(25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[0-9]{2}|[0-9])){3}$/
        .test(this.ipaddr)
    },
  },
  watch: {
    async profile (val) {
      if (val) await this.fetch()
    },
    controller (val) {
      this.openDialog(val)
    },
    dialog (val) {
      if (!val) {
        this.controller = null
      }
    }
  },
  mounted () {
    if (this.profile) this.fetch()
    setInterval(() => {
      this.controllers = this.controllers.map(x => {
        if (x.conn && x.conn.last) {
          x.conn.text = x.conn.last.fromNow()
          x.conn.age = Math.abs(x.conn.last.diff(moment(), 'seconds'))
        }
        return x
      })
    }, 30000)
  }
}
</script>

<style lang="css">
</style>
